import React from 'react'
import {
    createRegisterableComponentWithData,
    EditionLoader,
    Features,
} from '@news-mono/web-common'
import {
    NightlyPreviousSpecialEditionsProps,
    NightlyPreviousSpecialEditions,
} from './PreviousSpecialEditions'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@west-australian-newspapers/etrigan-feature-toggles-client'

export const NightlyPreviousSpecialEditionsRegistration =
    createRegisterableComponentWithData(
        'nightly-previous-special-editions',
        EditionLoader,
        (
            props: Omit<NightlyPreviousSpecialEditionsProps, 'onEvent'>,
            _,
            services,
        ) => {
            const { title, editions } = props
            const { toggles } = services.store.getState()
            const enabledEditions = editions.filter((edition) => {
                return isFeatureEnabled<Features>(
                    toFeatureState(toggles),
                    edition.featureToggle,
                    false,
                )
            })
            return (
                <NightlyPreviousSpecialEditions
                    title={title}
                    editions={enabledEditions}
                    onEvent={services.onEvent}
                />
            )
        },
    )
